module.exports = __webpack_public_path__ + "images/store_case_study/southleaf-pic1_c8cdb3b86f55544f9aed1e02bc0bf33d.png";